import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Industry pages
export const IndustryListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/industries/list')) as Promise<
      typeof import('@/pages/setting/industries/list')
    >
);

export const IndustryEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/industries/edit')) as Promise<
      typeof import('@/pages/setting/industries/edit')
    >
);

export const IndustryCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/industries/create')) as Promise<
      typeof import('@/pages/setting/industries/create')
    >
);

// Segment pages
export const SegmentListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/segments/list')) as Promise<
      typeof import('@/pages/setting/segments/list')
    >
);

export const SegmentEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/segments/edit')) as Promise<
      typeof import('@/pages/setting/segments/edit')
    >
);

export const SegmentCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/segments/create')) as Promise<
      typeof import('@/pages/setting/segments/create')
    >
);

// Life Cycle pages
export const LifeCycleListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/life-cycles/list')) as Promise<
      typeof import('@/pages/setting/life-cycles/list')
    >
);

export const LifeCycleEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/life-cycles/edit')) as Promise<
      typeof import('@/pages/setting/life-cycles/edit')
    >
);

export const LifeCycleCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/life-cycles/create')) as Promise<
      typeof import('@/pages/setting/life-cycles/create')
    >
);

// Churn Reason pages
export const ChurnReasonListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/churn-reasons/list')) as Promise<
      typeof import('@/pages/setting/churn-reasons/list')
    >
);

export const ChurnReasonEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/churn-reasons/edit')) as Promise<
      typeof import('@/pages/setting/churn-reasons/edit')
    >
);

export const ChurnReasonCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/churn-reasons/create')) as Promise<
      typeof import('@/pages/setting/churn-reasons/create')
    >
);

// Document Type pages
export const DocumentTypeListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/document-types/list')) as Promise<
      typeof import('@/pages/setting/document-types/list')
    >
);

export const DocumentTypeEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/document-types/edit')) as Promise<
      typeof import('@/pages/setting/document-types/edit')
    >
);

export const DocumentTypeCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/document-types/create')) as Promise<
      typeof import('@/pages/setting/document-types/create')
    >
);

// Contact Type pages
export const ContactTypeListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/contact-types/list')) as Promise<
      typeof import('@/pages/setting/contact-types/list')
    >
);

export const ContactTypeEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/contact-types/edit')) as Promise<
      typeof import('@/pages/setting/contact-types/edit')
    >
);

export const ContactTypeCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/contact-types/create')) as Promise<
      typeof import('@/pages/setting/contact-types/create')
    >
);

// Approval Flow pages
export const ApprovalFlowListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/approval-flows/list')) as Promise<
      typeof import('@/pages/setting/approval-flows/list')
    >
);

export const ApprovalFlowEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/approval-flows/edit')) as Promise<
      typeof import('@/pages/setting/approval-flows/edit')
    >
);

export const ApprovalFlowCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/approval-flows/create')) as Promise<
      typeof import('@/pages/setting/approval-flows/create')
    >
);
